import React from 'react';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import configureStore from './configureStore';
import Header from './Header';
import { getEmail, makeUserDetails, makeFetchApiStatus, getIsPartnerSite, getChatS3Url, getUserNotifications, gethasMoreNotification, getNotificationLoading, getUnreadNotificationsCount, getNotificationFilter, getUserTodos, getTodoLoading } from './Header.selector';
import { initUserEmail, fetchGetUserDetails, updateUserDetails, resetAPISuccessEvent, fetchChatConfig, fetchUnreadNotificationsCount, getChatAccessToken, fetchNotifications, setNotifications, setNotificationHasMore, updateNotification, setNotificationFilter, setUnreadNotificationCount, fetchUserTodos, addTodo, setPusherCred } from './Header.action';
export const store = configureStore();
const mapStateToProps = createStructuredSelector({
  email: getEmail(),
  userDetails: makeUserDetails(),
  isFetchApiSuccess: makeFetchApiStatus(),
  isPartnerSite: getIsPartnerSite(),
  chatS3Url: getChatS3Url(),
  notifications: getUserNotifications(),
  hasMore: gethasMoreNotification(),
  notificationLoading: getNotificationLoading(),
  unreadNotificationsCount: getUnreadNotificationsCount(),
  notificationFilter: getNotificationFilter(),
  todos: getUserTodos(),
  todoLoading: getTodoLoading()
});
const mapDispatchToProps = dispatch => ({
  initUserEmail: bindActionCreators(initUserEmail, dispatch),
  getUserDetails: bindActionCreators(fetchGetUserDetails, dispatch),
  updateUserDetailsData: bindActionCreators(updateUserDetails, dispatch),
  resetUserDetailAPIEvent: bindActionCreators(resetAPISuccessEvent, dispatch),
  fetchChatConfig: bindActionCreators(fetchChatConfig, dispatch),
  getChatAccessToken: bindActionCreators(getChatAccessToken, dispatch),
  fetchNotifications: bindActionCreators(fetchNotifications, dispatch),
  setNotifications: bindActionCreators(setNotifications, dispatch),
  setNotificationHasMore: bindActionCreators(setNotificationHasMore, dispatch),
  updateNotification: bindActionCreators(updateNotification, dispatch),
  setNotificationFilter: bindActionCreators(setNotificationFilter, dispatch),
  fetchUnreadNotificationsCount: bindActionCreators(fetchUnreadNotificationsCount, dispatch),
  setUnreadNotificationCount: bindActionCreators(setUnreadNotificationCount, dispatch),
  fetchUserTodos: bindActionCreators(fetchUserTodos, dispatch),
  addTodo: bindActionCreators(addTodo, dispatch),
  setPusherCred: bindActionCreators(setPusherCred, dispatch)
});
const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);
export default (props => /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(HeaderContainer, props)));